export default __webpack_public_path__ + "static/media/mobile-app-qr.a35361e8.png";